import {useState, useEffect} from "react";
import playgroundApi from "../../services/playgroundApi";
import {PlaylistLessonCard, PlaylistResponse} from "../../client/models/playlist/PlaylistResponse";
import { useParams } from 'react-router-dom';
import {ILibraryLessonCardProps} from "../cards/library-lesson-card/LibraryLessonCard";
import {useLibraryLessonCardNavigationLogic} from "../cards/library-lesson-card/LibraryLessonCardNavigation.logic";

export interface IPlaylistResultsLogic {
  isLoading: boolean;
  playlistResponse: PlaylistResponse;
  isCheckingWhetherLessonIsAccessible: boolean;
  calculateLessonCardProps(card: PlaylistLessonCard): ILibraryLessonCardProps;
}

export const usePlaylistResultsLogic = (): IPlaylistResultsLogic => {
  const [isLoading, setIsLoading] = useState(true);
  const [playlistResponse, setPlaylistResponse] = useState<PlaylistResponse>({id: 0, title: "", cards: []});
  const { playlistId } = useParams();
  const {onArrangementClick, isCheckingWhetherLessonIsAccessible} = useLibraryLessonCardNavigationLogic();
  const id = playlistId ? parseInt(playlistId) : 0;

  useEffect(() => {
    playgroundApi.playlist({playlistId: id})
      .then((response) => {
        setPlaylistResponse(response);
      }).finally(() => {
        setIsLoading(false);
      });
  }, []);

  function calculateLessonCardProps(card: PlaylistLessonCard): ILibraryLessonCardProps {
    return {
      title: card.title,
      lessonId: card.lessonId,
      difficultyIdentifier: card.difficultyIdentifier,
      difficultyName: card.levelDifficulty,
      imageUrl: card.imageUrl,
      icon: card.hasVideo ? "video" : "none",
      subTitle: card.artistName,
      onClick: onArrangementClick(card.lessonId),
    };
  }

  return {
    isLoading,
    playlistResponse,
    isCheckingWhetherLessonIsAccessible,
    calculateLessonCardProps,
  };
}
